import type {
  CustomerManagerCustomerSummary,
  OpsDirectoryUser,
} from '@nadoutong/contracts';

/**
 * Join identity parts for an ops-console label: keep first occurrence,
 * drop empty/whitespace, de-dupe case-insensitively, join with ` / `.
 */
export function joinIdentityParts(parts: readonly (string | null | undefined)[]): string {
  const seen = new Set<string>();
  const kept: string[] = [];
  for (const part of parts) {
    if (part === null || part === undefined) {
      continue;
    }
    const trimmed = part.trim();
    if (trimmed.length === 0) {
      continue;
    }
    const key = trimmed.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    kept.push(trimmed);
  }
  return kept.join(' / ');
}

export function opsUserIdentityLabel(id: string, user: OpsDirectoryUser | undefined): string {
  return joinIdentityParts([id, user?.display_name, user?.email, user?.feishu_name]);
}

export interface CustomerIdentityParts {
  readonly id: string | null;
  readonly company: string | null;
  readonly contact_name: string | null;
  readonly email: string | null;
}

export function customerIdentityParts(
  id: string,
  customer: CustomerManagerCustomerSummary | undefined,
): CustomerIdentityParts {
  return {
    id,
    company: customer?.company ?? null,
    contact_name: customer?.contact_name ?? null,
    email: customer?.email ?? null,
  };
}

export function customerIdentityLabel(
  id: string,
  customer: CustomerManagerCustomerSummary | undefined,
): string {
  const parts = customerIdentityParts(id, customer);
  return joinIdentityParts([parts.id, parts.company, parts.contact_name, parts.email]);
}
